'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var DayPickerInput = require('react-day-picker/DayPickerInput');
var reactDayPicker = require('react-day-picker');
var format = require('date-fns/format');
var dateFnsParse = require('date-fns/parse');
var faCalendar = require('@fortawesome/pro-solid-svg-icons/faCalendar');
require('react-day-picker/lib/style.css');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var DayPickerInput__default = /*#__PURE__*/_interopDefaultLegacy(DayPickerInput);
var format__default = /*#__PURE__*/_interopDefaultLegacy(format);
var dateFnsParse__default = /*#__PURE__*/_interopDefaultLegacy(dateFnsParse);

var _templateObject;
var CalendarWrapper = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  &&& {\n    .DayPickerInput-Overlay {\n      z-index: 5;\n    }\n    .DayPicker {\n      font-size: 12px;\n    }\n    .DayPicker-Day {\n      border-radius: 0px;\n      &:hover {\n        background-color: #f5f9fb;\n      }\n    }\n    .DayPicker-Day--today {\n      color: #007fa2;\n    }\n    .DayPicker-Day--selected {\n      color: white;\n      background-color: #007fa2;\n      .DayPicker-Day--today {\n        color: white;\n      }\n      &:hover {\n        background-color: #0e6d8c;\n      }\n    }\n    .DayPickerInput {\n      width: ", ";\n    }\n  }\n"])), function (props) {
  return props == null ? void 0 : props.width;
});
var FORMAT = 'dd/MM/yyyy';
CalendarInput.defaultProps = {
  width: '117px',
  datePickerProps: {
    disabledDays: {
      after: new Date()
    }
  }
};

function CalendarInput(props) {
  var disabled = props.disabled,
      placeholder = props.placeholder,
      input = props.input,
      inputProps = props.inputProps,
      field = props.field,
      onChange = props.onChange,
      value = props.value,
      width = props.width,
      datePickerProps = props.datePickerProps;

  var _React$useState = React__default["default"].useState(false),
      focus = _React$useState[0],
      setFocus = _React$useState[1];

  var inputFieldRef = React__default["default"].useRef(null); // @ts-expect-error TS(7006): Parameter 'date' implicitly has an 'any' type.

  function handleChangeDay(date, modifiers, e) {
    var _inputFieldRef$curren, _inputFieldRef$curren2, _inputFieldRef$curren3, _inputFieldRef$curren4;

    var newDate = formatDate(date, FORMAT, undefined); // Check if a typed value exists, by removing the masked characters (__/__/____)
    // @ts-expect-error TS(2339): Property 'value' does not exist on type 'never'.

    var hasTypedValue = Boolean(inputFieldRef == null ? void 0 : (_inputFieldRef$curren = inputFieldRef.current) == null ? void 0 : (_inputFieldRef$curren2 = _inputFieldRef$curren.value) == null ? void 0 : (_inputFieldRef$curren3 = _inputFieldRef$curren2.replace(/\//g, '')) == null ? void 0 : (_inputFieldRef$curren4 = _inputFieldRef$curren3.replace(/_/g, '')) == null ? void 0 : _inputFieldRef$curren4.trim()); // The date can either be typed into the input field, or selected from the calendar.

    var isDateTypedInField = Boolean(!newDate && hasTypedValue);

    if (isDateTypedInField) {
      var _inputFieldRef$curren5;

      // @ts-expect-error TS(2339): Property 'value' does not exist on type 'never'.
      onChange(inputFieldRef == null ? void 0 : (_inputFieldRef$curren5 = inputFieldRef.current) == null ? void 0 : _inputFieldRef$curren5.value);
      setFocus(true);
    } else if (newDate) {
      onChange(newDate);
      setFocus(false);
      e.hideAfterDayClick();
    } else {
      onChange(undefined);
      setFocus(!focus);
    }
  } // @ts-expect-error TS(7006): Parameter 'str' implicitly has an 'any' type.


  function parseDate(str, format, locale) {
    var parsed = dateFnsParse__default["default"](str, format, new Date(), {
      locale: locale
    });

    if (reactDayPicker.DateUtils.isDate(parsed)) {
      return parsed;
    }

    return undefined;
  } // @ts-expect-error TS(7006): Parameter 'date' implicitly has an 'any' type.


  function formatDate(date, format, locale) {
    if (!date) return undefined;
    return format__default["default"](date, format, {
      locale: locale
    });
  }

  return /*#__PURE__*/React__default["default"].createElement("label", null, /*#__PURE__*/React__default["default"].createElement(CalendarWrapper, {
    width: width
  }, /*#__PURE__*/React__default["default"].createElement(DayPickerInput__default["default"], {
    keepFocus: false,
    onDayChange: function onDayChange(day, modifiers, e) {
      return handleChangeDay(day, modifiers, e);
    },
    dayPickerProps: datePickerProps,
    onDayPickerHide: function onDayPickerHide() {
      return setFocus(false);
    },
    value: value // @ts-expect-error TS(2769): No overload matches this call.
    ,
    formatDate: formatDate,
    format: FORMAT,
    parseDate: parseDate,
    placeholder: placeholder,
    inputProps: {
      disabled: disabled
    } // @ts-expect-error TS(7006): Parameter 'pickerProps' implicitly has an 'any' ty... Remove this comment to see the full error message
    ,
    component: function component(pickerProps) {
      return /*#__PURE__*/React__default["default"].createElement(bumbag.InputField, _extends__default["default"]({
        after: /*#__PURE__*/React__default["default"].createElement(bumbag.Input.Icon, {
          "aria-label": "Search",
          color: "white900" // @ts-expect-error
          ,
          icon: faCalendar.faCalendar,
          type: "font-awesome"
        }),
        autoComplete: "off" // @ts-expect-error TS(2783): 'value' is specified more than once, so this usage... Remove this comment to see the full error message
        ,
        value: value,
        autoFocus: focus
      }, input, field, props, inputProps, pickerProps, {
        onBlur: function onBlur(e) {
          pickerProps.onBlur(e);
          props.onBlur(e);
        },
        width: width,
        inputRef: inputFieldRef
      }));
    }
  })));
}

CalendarInput.ReduxForm = bumbag.reduxFormField(CalendarInput, {
  hasFieldWrapper: true
});
CalendarInput.Formik = bumbag.formikField(CalendarInput, {
  hasFieldWrapper: true,
  useValue: true
});

exports["default"] = CalendarInput;
